<template>
  <path d="M8.33336 12.6433L15.9934 4.98251L17.1725 6.16085L8.33336 15L3.03003 9.69668L4.20836 8.51835L8.33336 12.6433Z"/>
</template>

<script>
export default {
  name: "IconCheckFill"
}
</script>

<style scoped>

</style>